<div *ngIf="items" class="difficulties flex space-1">
  <ng-container *ngFor="let item of items; let last = last">
    <div>
      <label>{{ item.Title }}</label>
      <span>{{ item.Value }}</span>
    </div>
    <div class="seperator" *ngIf="!last">·</div>
  </ng-container>
</div>
